import React, { useEffect } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDStack, tokens,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { dataAttrs } from 'Helpers/Testing';
import { ScenarioAcceptContinueButton } from 'Views/Page/Content/Modal/Layouts/ScenarioAcceptCommon/ScenarioAcceptContinueButton';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import { LottieControl } from 'Components/ComponentLibrary/Organisms/LottieControl';
import { useLottieLoadingContext } from 'Components/ComponentLibrary/Organisms/LottieControl/LottieLoadingLayout';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const useStyles = buildUseStyles('ScenarioAcceptanceConfirmStep', (theme) => ({
  subtitle: {
    '& > p > div > span > span:last-of-type': {
      color: tokens.color_sunset_500,
    },
  },
  lottie: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: 'auto',
    padding: theme.spacing(2),
    '& rect': {
      fill: tokens.color_oceana_800,
    },
  },
}));

const Layout = () => {
  const { onSubmit, saving, resource } = useMetaLayoutContext();
  const { refreshHouseholdResource } = useSimpleHousehold();
  const { setIsContentShowing } = useLottieLoadingContext();
  const classes = useStyles();

  const handleSubmit = async () => {
    await onSubmit();
    await refreshHouseholdResource();
  };

  useEffect(() => {
    setIsContentShowing(false);
  }, []);

  return (
    <FDStack direction={'column'} justifyContent={'space-between'} height={'100%'} width={'100%'}>
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" alignItems={'stretch'} spacing={1}>
          {resource.withRelationship(fr.relationships.lottie.name,
            (rel) => (
              <div className={classes.lottie}>
                <LottieControl
                  onLoadSuccess={() => setIsContentShowing(true)}
                  src={rel.link('related').url()}
                  width="300px"
                  height="auto"
                />
              </div>),
            () => null)}
          <MetaControlField attr={'title'} {...dataAttrs('select-your-scenario-confirm-title')} />
          <div className={classes.subtitle}>
            <MetaControlField attr={'subtitle'} />
          </div>
        </FDStack>
      </DialogContent>
      <DialogActions>
        <ScenarioAcceptContinueButton onClick={handleSubmit} resource={resource} label="Let's do it →" loading={saving} />
      </DialogActions>
    </FDStack>
  );
};

export default Layout;
